// TODO: implement banner component when BE will be ready
const CategoryBanner = ({ banner }) => {
    if (!banner)
        return null;
    return null;
    // return <div className="category-banner" dangerouslySetInnerHTML={{ __html: banner.data }} />;
};

export { CategoryBanner as C };
//# sourceMappingURL=CategoryBanner-Jp_beYYn.js.map
